import React, { useContext } from 'react';
import {addIndex,  map,  sort,  pipe, compose,toUpper } from 'ramda';

import styleFile from './ModalInfoStarTraveler.js';
import { Image, Button, RichText } from '@synergycms_core/components/generic/';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import Modal from '@synergycms_core/components/generic/Modal';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import MoreInfoFold from '../MoreInfoFold/MoreInfoFold.jsx'


import {connect} from 'react-redux';
import Slide, { SlideItem, SlideContext, ButtonSlide } from '@synergycms_core/components/generic/Slide';


function getLoyaltyInfoString(tier) {
  if (tier.min_bookings && tier.max_bookings) {
    return `${tier.min_bookings}-${tier.max_bookings}`;
  } else if (!tier.min_bookings && tier.max_bookings.length) {
    return `+${tier.max_bookings}`;
  }
  return;
}

export const getSTLogoByTier = (code) => {
  switch(code) {
    case "blue":
      return "stBlueLogo";
    case "silver":
      return "stSilverLogo";
    case "gold":
      return "stGoldLogo";
    default:
      return "stDefaultLogo";
  }
}

const TierWrapper = compose(PropertyManager(['tier', 'tiers', 'classes', 'mobileTable']))(
  function TierWrapper(props) {
    const { classes, mobileTable  } = props.config;
    const slideContext = useContext(SlideContext);
    let tier;
    if(props.config.tiers) {
      tier = props.config.tiers[slideContext.index]
    } else {
      tier = props.config.tier;
    }

    const stIcon = getSTLogoByTier(tier.code);
    return (
      <div className={[classes.tierInfo, mobileTable && classes.mobileTable].join(' ')}>
        <Image
          svg={stIcon}
        />
        <div className={classes.richtextRequiredBooks}>
          <RichText
            translate={true}
            text={'_%{required_books} reservas%_'}
            withVars={{ required_books: getLoyaltyInfoString(tier) }}
          />
          &nbsp;
          <RichText translate={true} text={'_%en 1 año%_'} />
        </div>
      </div>
    );
  }
);


export const getTierColor = (code, className) => {

  let tierColor = {}
  switch (code) {

    case "blue" :
      tierColor = {
        className: 'stBlueTier',
      }
      break;

    case "silver" :
      tierColor = {
        className: 'stSilverTier',
      }
      break;

    case "gold" :
      tierColor = {
        className: 'stGoldTier',
      }
      break;

    default :
      tierColor = {
        className: 'stDefault',
      }
  }

  return className ? tierColor.className : tierColor.color;
};

function BenefitsRow(props) {
  const {benefit, tiers, classes} = props
  const hasSubtitle = benefit.subtitle.length > 0;
  const hasDescription = benefit.description.length > 0;
  const classesBenefits = {
    tierContent: classes.tierContent,
    stSilverTier: classes.stSilverTier,
    stGoldTier: classes.stGoldTier,
    stBlueTier: classes.stBlueTier,
    stDefault: classes.stDefault,
  }
  const benefitIconSyn = benefit.icon ? process.env.URL_ENVIRONMENT + '/api/medias/' + benefit.icon : false;

  return (
    <tr>
      <td className={classes.advantageValue}>
        <div className={classes.benefitsContainer}>
          <div className={classes.benefitIconContainer}>
            {benefitIconSyn &&
              <Image remoteSvg={true} svg={benefitIconSyn} innerStyle={classes.benefitIcon} />
            }
          </div>
          <div className={classes.benefitText}>
            <RichText text={benefit.title} innerStyle={classes.advantageName} />
            {hasSubtitle && hasDescription && (
                <MoreInfoFold innerStyle={classes.subtitleText} triggerDropTitle={benefit.subtitle} dropText={benefit.description}/>
            )}
            {hasSubtitle && !hasDescription && <RichText text={benefit.subtitle} innerStyle={classes.subtitleText} />}
          </div>
        </div>
      </td>
      {tiers.map((tier, idx) => (
        <td className={classes.tiersValue} key={idx}>
          <BenefitsTierDetail tier={tier} benefit={benefit} key={idx} classesBenefits={classesBenefits} />
        </td>
      ))}
    </tr>
  );
}

function BenefitsTierDetail(props) {
  const benefit= props.benefit;
  const classes = props.classesBenefits
  const benefitActiveTiers = benefit.active_tiers.map(
    (activeTier) => {
      return activeTier.tier_id;
    }
  );

  let currentBenefit;
  benefit.active_tiers.forEach((benefitByTier) => {
    if (benefitByTier.tier_id === props.tier.id) {
      currentBenefit = benefitByTier;
    }
  });

  let content;
  if (benefitActiveTiers.includes(props.tier.id)) {
    // eslint-disable-next-line default-case
    switch (currentBenefit.field_type) {
      case 'bool':
        content = <Image svg={'starTravelerCircle'} />;
        break;
      case 'text':
        content = <RichText text={currentBenefit.value} />;
        break;
    }
  }

  let colorTier = getTierColor(props.tier.code, true)

  return (
    <div className={[classes.tierContent, classes[colorTier]].join(' ')}>
      {content}
    </div>
  );
}


export const BenefitsTableDesktop =
  compose(PropertyManager(['tiers', 'advantages', 'classes']))(
    function BenefitsTableDesktop(props) {
      const tiers = addIndex(map)((tier, idx) => {
        return { id: tier.id, weight: tier.weight, code: tier.code, max_bookings: tier.max_bookings, min_bookings: tier.min_bookings };
      })(props.config.tiers);
      const classes = props.config.classes

      const advantages= pipe(
        map((advantage) => {
          return {
            title: advantage.title,
            subtitle: advantage.subtitle,
            active_tiers: advantage.extended.tier_advantages,
            code: advantage.code,
            description: advantage.description,
            clickEnabled: advantage.click_enabled,
            icon: advantage.icon,
            image: advantage.image,
          };
        }),
        sort((a, b) => b.active_tiers.length - a.active_tiers.length)
      )(props.config.advantages);

      return (
        <div>
          <table className={classes.advantagesTable}>
            <tbody>
              <tr className={classes.trTiersLogo}>
                <td></td>
                {tiers.map((tier, idx) => (
                  <td className={"tiersLogo"} key={idx}>
                    <TierWrapper tier={tier} key={idx} classes={classes} />
                  </td>
                ))}
              </tr>
              {advantages.map((benefit, idx) => (
                <BenefitsRow benefit={benefit} key={idx} tiers={tiers} classes={classes} />
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  );

export const BenefitsTableMobile = compose(
    PropertyManager(['tiers', 'advantages', 'classes']),
  )(function BenefitsTableMobile(props) {

    const advantages= pipe(
      map((advantage) => {
        return {
          title: advantage.title,
          subtitle: advantage.subtitle,
          active_tiers: advantage.extended.tier_advantages,
          code: advantage.code,
          description: advantage.description,
          clickEnabled: advantage.click_enabled,
          icon: advantage.icon,
          image: advantage.image,
        };
      }),
      sort((a, b) => b.active_tiers.length - a.active_tiers.length)
    )(props.config.advantages);
    const classes = props.config.classes
    const {tiers} = props.config;

    return (
      <div className={classes.slideContainer}>
        <Slide wrapper={classes.sliderWrapper} wrapperContent={classes.minHeightWraper} transitionSpeed={300}>
          <div className={classes.buttonsContainer}>
            <div className={classes.superiorWrapper}>
              <ButtonSlide
                innerStyle={[classes.buttonSlide, classes.prevButton].join(' ')}
                showButtons={true}
                direction={'prev'}
              />
              <TierWrapper className={classes} tiers={tiers} classes={classes} mobileTable={true}/>
              <ButtonSlide
                innerStyle={[classes.buttonSlide, classes.nextButton].join(' ')}
                showButtons={true}
                direction={'next'}
              />
            </div>
            {/* <SlideDots className={classes.slideDots} /> */}
          </div>
          {tiers.map((tier, idx) => (
            <SlideItem text={toUpper(tier.code)} contentKey={tier.code} key={tier.code} min={2} innerStyle={classes.levelST}>
              <table className={[classes.benefitsTable, classes.advantagesTable, classes.mobileTable].join(' ')}>
                <tbody>
                  {advantages.map((benefit, idx) => (
                    <BenefitsRow benefit={benefit} key={idx} tiers={[tier]} classes={classes} />
                  ))}
                </tbody>
              </table>
            </SlideItem>
          ))}
        </Slide>
      </div>
    );
    }
  );


const mapStateToProps = (store) => {
  return {
    tiers: store.getIn(['customer', 'loyalty', 'data','tiers']).toJS(),
    advantages: store.getIn(['customer', 'loyalty', 'data','advantages']).toJS()
  };
};

export const BenefitsTable =  compose(
    connect(mapStateToProps),
    PropertyManager(['tiers', 'advantages', 'theme']),
    withThemeJSS({ styleFile, displayName: 'BenefitsTable', link: true, index: 200 })
  )(function BenefitsTable(props) {
    const { config, theme } = props
    const { classes } = theme.styles;
    if (theme.isTactileDevice()) {
      return (
        <BenefitsTableMobile
          config={config}
          classes={classes}
        />
      );
    } else {
      return (
        <BenefitsTableDesktop
          config={config}
          classes={classes}
        />
      );
    }
  });

export const RoomInfoBlock = compose(
  connect(mapStateToProps),
  PropertyManager(['advantages','starTravelerTiers','tiers']),
  withThemeJSS({ styleFile, displayName: 'ModalInfoST' }, null, 'tabTitle')
  )(
  class RoomInfoBlock extends React.Component {
    static displayName = 'RoomInfoBlock';
  
    constructor(props) {
      super(props);
      this.state = {
        modalDescriptionBlock: true,
        modalServicesBlock: true
      };
    }
  
    render() {
      const { theme } = this.props

      const { classes  } = theme.styles;
      return (
        <div>
          <div className={classes.infoBlock}>
            <div className={classes.infoDiscover}>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%descubre nuestro club de fidelización%_'}
                innerStyle={[classes.subTitleST]}
              />
              <RichText
                translate={true}
                ucFirst={true}
                dangerouslySetInnerHTML={'_%selecciona la tarifa Star Traveler y disfruta de un 10% de descuento adicional en tus estancias. Sino eres miembro del club de fidelización, te daremos de alta gratuitamente al completar tu reserva%_'}
                innerStyle={[classes.descriptionText]}
              />
            </div>
            {/* general advantages */}
            <div className={classes.infoAdvantages}>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%ventajas generales Star Traveler%_'}
                innerStyle={[classes.subTitleST]}
              />
              <div className={classes.advantagesContainer}>
                <div className={classes.advantage}>
                  <div className={classes.imageAdvantage}>
                    <Image svg={'stIcon10Percent'}/>
                  </div>
                  <div className={classes.descriptionAdvantages}>
                    <RichText
                      translate={true}
                      ucFirst={true}
                      text={'_%10% descuento%_'}
                      innerStyle={[classes.descriptionText]}
                    />
                    {/*<RichText
                      translate={true}
                      ucFirst={true}
                      text={'_%mejor precio garantizado%_'}
                      innerStyle={['roboto13Gray']}
                    />*/}
                  </div>
                </div>
                <div className={classes.advantage}>
                  <div className={classes.imageAdvantage}>
                    <Image svg={'diamond'}/>
                  </div>
                  <div className={classes.descriptionAdvantages}>
                    <RichText
                      translate={true}
                      ucFirst={true}
                      text={'_%beneficios exclusivos%_'}
                      innerStyle={[classes.descriptionText]}
                    />
                    {/*<RichText
                      translate={true}
                      ucFirst={true}
                      text={'_%en todas las estancias%_'}
                      innerStyle={['roboto13Gray']}
                    />*/}
                  </div>
                </div>
                <div className={classes.advantage}>
                  <div className={classes.imageAdvantage}>
                    <Image svg={'starLoyalty'}/>
                  </div>
                  <div className={classes.descriptionAdvantages}>
                    <RichText
                      translate={true}
                      ucFirst={true}
                      text={'_%puntos acumulables%_'}
                      innerStyle={[classes.descriptionText]}
                    />
                    {/*<RichText
                      translate={true}
                      ucFirst={true}
                      text={'_%en cada reserva%_'}
                      innerStyle={['roboto13Gray']}
                    />*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  );

const InfoStarTravelerModal = class InfoStarTravelerModal extends React.Component {
  static displayName = 'InfoStarTravelerModal';

  constructor(props) {
    super(props);
    this.state = {
      width:null,
    };
    this.widthRef = React.createRef();
  }

  getWidthComponent = () => {
    if(this.widthRef.current){
      this.setState({
        width: this.props.theme.getDesirableWidth(this.widthRef.current.offsetWidth)
      });
    }
  }

  componentDidMount() {
    this.getWidthComponent();
  }

  render() {
    const { config, classes, resizableImages } = this.props;
    return (
      <div className={classes.modalTabsList} ref={this.widthRef}>
        <div className={classes.headerModal}>
          <RichText innerStyle={classes.stModalTitle} text={'Star Traveler'} />
        </div>
        <RoomInfoBlock advantages={config.advantages} starTravelerTiers={config.starTravelerTiers} config={config}/>
        <BenefitsTable classes={classes} config={config} resizableImages={resizableImages}/>
      </div>
    );
  }
};

const ModalInfoST = class ModalInfoST extends React.Component {
  static displayName = 'ModalInfoST';
  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const ButtonContent = config.buttonContent;
    const resizableImages = theme.resizableImages;
    return (
      <Modal
        contentStyle={classes.stInfoModalContent}
        closeButtonStyle={[classes.closeButton, 'mainColor']}
        modalStyle={classes.stInfoModalStyle}
        popover={closeMethod => <InfoStarTravelerModal theme={theme} classes={classes} config={config} resizableImages={resizableImages}/>}
        typeModal={'roomDetailTooltip'}>
        {/* button to open the modal */}
        <Button ariaLabel={'ModalInfoST'} id={config.id} tabIndex={-1}>
          <ButtonContent />
        </Button>
      </Modal>
    );
  }
};

export default compose(
  PropertyManager(['roomInfo', 'roomName', 'hotelInfo', 'buttonContent', 'travelClubEnabled', 'id']),
  withThemeJSS({ styleFile, link: true, index: 200 })
)(ModalInfoST);


